import React from 'react';
import LiteracyDay2023 from 'views/Literaryclub2023/LiteracyDay2023';

const LifeSkillPage = () => {
  return <LiteracyDay2023/>;
};

export default LifeSkillPage;